import React, { useEffect, useRef, useState } from 'react';
import '../CSS/Global.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './SideBar';
import { useSidebar } from '../SidebarContext';
import Header from './Header';

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const CommercialEdit = () => {
    const { isSidebarOpen } = useSidebar();
    const [amenities, setAmenities] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [locationAdvantages, setLocationAdvantages] = useState([]);
    const [selectedLocationAdvantages, setSelectedLocationAdvantages] = useState([]);
    const [availabilityStatus, setAvailabilityStatus] = useState("");
    const fileInputRef = useRef(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [dragging, setDragging] = useState(false);
    const [errors, setErrors] = useState({});
    const [load, setLoad] = useState(true);
    const [watersupply, setWaterSupply] = useState([]);
    const [selectedWaterSupply, setSelectedWaterSupply] = useState([]);
    const [security, setSecurity] = useState([]);
    const [selectedsecurity, setSelectedSecurity] = useState([]);

    const [data, setData] = useState({
        building_name: "",
        address: "",
        city: "",
        floorPlan: "",
        flatType: [],
        carpetArea: [{ carpetArea: "", price: "" }],
        buildupArea: "",
        totalFloors: "",
        floorLevel: "",
        bedrooms: "",
        jodi1: "",
        jodi2: "",
        bathrooms: "",
        balconies: "",
        availability: "",
        ageOfBuilding: "",
        possesionTill: "",
        ownership: "",
        facing: "",
        maintenance: "",
        parking: "",
        booking_amount: "",
        virtual_tour: "",
        furnishStatus: "",
        category: "",
        dev_logo: "",
        developer_name: '',
        developer_description: '',
        property_description: '',

        rkCarpetAreas: [{ value: "", showMinus: false }],
        rkBuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        rkSuperBuiltUpAreas: [{ value: "", showMinus: false }],
        rkExpectedPrices: [{ value: '' }],
        rkBalconies: '',
        rkBathrooms: '',
        rkFurnishStatus: '',
        rkConditionOfFlat: '',
        rkMonthlyMaintenance: '',
        rkPriceAllInclusive: '',
        rkPriceNegotiable: '',
        rkPreferredCashType: [],
        rkLoanFacility: '',
        rkDocumentsAvailable: '',
        rkFloorPlan: '',

        // 1BHK-specific fields
        bhk1CarpetAreas: [{ value: "", showMinus: false }],
        bhk1BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk1SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk1ExpectedPrices: [{ value: '' }],
        bhk1Bedrooms: '',
        bhk1BedroomsJodi1: '',
        bhk1BedroomsJodi2: '',
        bhk1Balconies: '',
        bhk1Bathrooms: '',
        bhk1FurnishStatus: '',
        bhk1ConditionOfFlat: '',
        bhk1MonthlyMaintenance: '',
        bhk1PriceAllInclusive: '',
        bhk1PriceNegotiable: '',
        bhk1PreferredCashType: [],
        bhk1LoanFacility: '',
        bhk1DocumentsAvailable: '',
        bhk1FloorPlan: '',





        extra1: "",
        extra2: ""
    })
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const navigate = useNavigate();

    const { id } = useParams();

    const handleAmenityChange = (event) => {
        const { value } = event.target;
        if (selectedAmenities.includes(value)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== value));
        } else {
            setSelectedAmenities([...selectedAmenities, value]);
        }
    };

    const handleLocationAdvantageChange = (event) => {
        const { value } = event.target;
        if (selectedLocationAdvantages.includes(value)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== value)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, value]);
        }
    };



    const [showCarpet, setShowCarpet] = useState(false);
    const [showSuperBuiltUp, setShowSuperBuiltUp] = useState(false);
    const [viewBedroomsMore, setViewBedroomsMore] = useState(false);
    const [viewBalconiesMore, setViewBalconiesMore] = useState(false);
    const [viewBathroomsMore, setViewBathroomsMore] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const [superBuiltUpAreas, setSuperBuiltUpAreas] = useState([{ value: "", showMinus: false }]);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };


    // const handleDeleteImage = async (imageName) => {
    //     // ✅ Step 1: Remove image from the UI immediately
    //     // const updatedImages = data.formImages.filter(img => img !== imageName);
    //     // setData((prevData) => ({
    //     //     ...prevData,
    //     //     formImages: updatedImages
    //     // }));



    // };

    const handleDeleteImage = async (index) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/commercial/updatedelete-property/${id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ deletedImageIndex: index }), // ✅ Send index
            });

            const result = await response.json();
            if (response.ok) {

                // ✅ Remove image from frontend state
                // setUploadedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
                fetchData();
                // alert("Image deleted successfully!");
            } else {
                toast.error(result.message || "Error deleting image");
            }
        } catch (error) {
            console.error("Error deleting image:", error);
            toast.error("Error deleting image");
        }
    };

    const maxFiles = 20; // Max number of files
    const maxSize = 20 * 1024 * 1024; // 20MB size limit in bytes

    const handleBrowseClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click(); // Trigger the hidden file input
    };

    const formatFileSize = (size) => {
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };

    const flatTypeFields = {
        "1RK": [
            "rkCarpetAreas", "rkBuiltUpAreas", "rkExpectedPrices", "rkBalconies", "rkBathrooms",
            "rkFurnishStatus", "rkConditionOfFlat", "rkMonthlyMaintenance", "rkPriceAllInclusive", "rkPriceNegotiable",
            "rkPreferredCashType",
        ],
        "1BHK": [
            "bhk1CarpetAreas", "bhk1ExpectedPrices", "bhk1Bedrooms", "bhk1Balconies", "bhk1Bathrooms",
            "bhk1FurnishStatus", "bhk1ConditionOfFlat", "bhk1MonthlyMaintenance", "bhk1PriceAllInclusive",
            "bhk1PriceNegotiable", "bhk1PreferredCashType",
        ],
        "2BHK": [
            "bhk2CarpetAreas", "bhk2ExpectedPrices", "bhk2Bedrooms", "bhk2Balconies", "bhk2Bathrooms",
            "bhk2FurnishStatus", "bhk2ConditionOfFlat", "bhk2MonthlyMaintenance", "bhk2PriceAllInclusive",
            "bhk2PriceNegotiable", "bhk2PreferredCashType",
        ],
        "3BHK": [
            "bhk3CarpetAreas", "bhk3ExpectedPrices", "bhk3Bedrooms", "bhk3Balconies", "bhk3Bathrooms",
            "bhk3FurnishStatus", "bhk3ConditionOfFlat", "bhk3MonthlyMaintenance", "bhk3PriceAllInclusive",
            "bhk3PriceNegotiable", "bhk3PreferredCashType",
        ],
        "4BHK": [
            "bhk4CarpetAreas", "bhk4ExpectedPrices", "bhk4Bedrooms", "bhk4Balconies", "bhk4Bathrooms",
            "bhk4FurnishStatus", "bhk4ConditionOfFlat", "bhk4MonthlyMaintenance", "bhk4PriceAllInclusive",
            "bhk4PriceNegotiable", "bhk4PreferredCashType",
        ]
    };


    const validateFields = () => {
        const newErrors = {};

        // Validate general required fields
        const generalRequiredFields = [
            "building_name",
            "address",
            "city",
            ...Object.keys(flatTypeFields)
                .filter((type) => data.flatType.includes(type)) // Validate only selected flat types
                .flatMap((type) => flatTypeFields[type]),
            "category",
        ];

        generalRequiredFields.forEach((field) => {
            const value = data[field];
            if (
                value === undefined ||
                value === null ||
                (typeof value === "string" && value.trim() === "") ||
                (Array.isArray(value) && value.length === 0)
            ) {
                newErrors[field] = "This field is required*";
            }
        });

        // Validate flatType-specific fields
        data.flatType.forEach((type) => {
            const fieldsForType = flatTypeFields[type] || [];
            fieldsForType.forEach((field) => {
                const value = data[field] ?? '';

                if (flatTypeFields[data.flatType]?.includes(field)) {
                    if (
                        value === undefined ||
                        value === null ||
                        (Array.isArray(value) && value.length === 0) ||
                        (typeof value === 'string' && value.trim() === '')
                    ) {
                        newErrors[field] = 'This field is required*';
                    }
                } else if (
                    value === undefined ||
                    value === null ||
                    (Array.isArray(value) && value.length === 0) ||
                    (typeof value === 'string' && value.trim() === '')
                ) {
                    newErrors[field] = 'This field is required*';
                }
            });
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };



    const addInput = () => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: [...prevData.carpetArea, { carpetArea: "", price: "" }],
        }));
    };

    const deleteInput = (index) => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: prevData.carpetArea.filter((_, i) => i !== index),
        }));
    };


    const handleDynamicChange = (e, fieldName, index, fieldKey = "value") => {
        const { value } = e.target;

        setData((prevState) => {
            const updatedField = Array.isArray(prevState[fieldName]) // Ensure it's an array
                ? [...prevState[fieldName]]
                : []; // If not, initialize it as an empty array

            // Update the specific field (value or expectedPrice)
            updatedField[index] = {
                ...updatedField[index],
                [fieldKey]: value,
            };

            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };

    const handleAddField = (fieldName) => {
        setData((prevState) => ({
            ...prevState,
            [fieldName]: [
                ...prevState[fieldName],
                { value: "", expectedPrice: "", showMinus: false },
            ],
        }));
    };

    const handleRemoveField = (fieldName, index) => {
        setData((prevState) => {
            const updatedField = [...prevState[fieldName]];
            updatedField.splice(index, 1); // Remove the field at the given index
            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };


    const handleEnterPress = (e, type) => {
        if (e.key === "Enter") {
            const value = e.target.value;
            if (Number(value) >= 5) {
                setData((prev) => ({
                    ...prev,
                    [type]: String(value),
                }));
            }
        }
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        const validFiles = files.filter(file =>
            file.size <= maxSize &&
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]);
    };

    const handleDeleteFile = (index) => {
        setUploadedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const toggleAmenity = (amenity) => {
        if (selectedAmenities.includes(amenity)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== amenity));
        } else {
            setSelectedAmenities([...selectedAmenities, amenity]);
        }
    };

    const toggleLocationAdvantage = (advantage) => {
        if (selectedLocationAdvantages.includes(advantage)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== advantage)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, advantage]);
        }
    };


    const toggleWaterSupply = (advantage) => {
        if (selectedWaterSupply.includes(advantage)) {
            setSelectedWaterSupply(
                selectedWaterSupply.filter((item) => item !== advantage)
            );
        } else {
            setSelectedWaterSupply([...selectedWaterSupply, advantage]);
        }
    };

    const toggleSecurity = (advantage) => {
        if (selectedsecurity.includes(advantage)) {
            setSelectedSecurity(
                selectedsecurity.filter((item) => item !== advantage)
            );
        } else {
            setSelectedSecurity([...selectedsecurity, advantage]);
        }
    };

    const handleDragLeave = () => setDragging(false);

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);

        const files = Array.from(event.dataTransfer.files);

        const validFiles = files.filter(file =>
            file.size <= maxSize &&
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]);
    };

    const handleRemoveTag = (index, type) => {
        const updatedList = type === 'amenities'
            ? amenities.split(',').filter((_, i) => i !== index).join(',')
            : locationAdvantages.split(',').filter((_, i) => i !== index).join(',');

        type === 'amenities' ? setAmenities(updatedList) : setLocationAdvantages(updatedList);
    };



    // 4BHK section
    const render1BHKSection = () => {
        return (
            <div className='render-commercial'>
                {/* Built-up Area and Expected Price */}
                <div>
                    <label>Carpet Area (Sq.ft) & Expected Price</label>
                    {data.bhk1BuiltUpAreas.map((area, index) => (
                        <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={{ flex: 1 }}>
                                <input
                                    type="text"
                                    placeholder="Enter Carpet Area"
                                    value={area.value}
                                    onChange={(e) => handleDynamicChange(e, "bhk1BuiltUpAreas", index, "value")}

                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <input
                                    type="text"
                                    placeholder="Enter Expected Price"
                                    value={
                                        area.expectedPrice && !isNaN(area.expectedPrice)
                                            ? Number(area.expectedPrice).toLocaleString("en-IN")
                                            : area.expectedPrice || ""
                                    }
                                    onChange={(e) => {
                                        const plainNumber = e.target.value.replace(/,/g, '');
                                        handleDynamicChange({ target: { value: plainNumber } }, "bhk1BuiltUpAreas", index, "expectedPrice");
                                    }}

                                />
                                <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                    {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                </small>
                            </div>
                            <div style={{ marginTop: 10 }}>
                                {index === data.bhk1BuiltUpAreas.length - 1 ? (
                                    <i className="fa-solid fa-plus" onClick={() => handleAddField("bhk1BuiltUpAreas")} style={{ cursor: 'pointer' }}></i>
                                ) : (
                                    <i className="fa-solid fa-minus" onClick={() => handleRemoveField("bhk1BuiltUpAreas", index)} style={{ cursor: 'pointer' }}></i>
                                )}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Furnish Status */}
                <div>
                    <label>Furnish Status</label>
                    <div className="radio-group">
                        {["Furnished", "Unfurnished", "Semi-furnished"].map((status) => (
                            <div className="radio-option" key={status}>
                                <input
                                    type="radio"
                                    name="bhk1FurnishStatus"
                                    value={status}
                                    id={`furnish-${status}`}
                                    checked={data.bhk1FurnishStatus === status}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`furnish-${status}`}>{status}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1FurnishStatus && <span className="error">This field is required*</span>}
                </div>

                {/* Condition of Flat */}
                <div>
                    <label>Condition of Flat</label>
                    <input
                        type="text"
                        name="bhk1ConditionOfFlat"
                        value={data.bhk1ConditionOfFlat}
                        onChange={handleInputChange}
                        placeholder="Enter condition of flat"
                    />
                    {errors.bhk1ConditionOfFlat && <span className="error">This field is required*</span>}
                </div>

                {/* Monthly Maintenance */}
                <div>
                    <label>Monthly Maintenance</label>
                    <input
                        type="text"
                        name="bhk1MonthlyMaintenance"
                        value={data.bhk1MonthlyMaintenance}
                        onChange={handleInputChange}
                        placeholder="Enter Monthly Maintenance"
                    />
                    {errors.bhk1MonthlyMaintenance && <span className="error">This field is required*</span>}
                </div>

                {/* Price All Inclusive */}
                <div>
                    <label>Price All Inclusive</label>
                    <div className="radio-group">
                        {["Yes", "No"].map((val) => (
                            <div className="radio-option" key={val}>
                                <input
                                    type="radio"
                                    name="bhk1PriceAllInclusive"
                                    value={val}
                                    id={`price-inclusive-${val}`}
                                    checked={data.bhk1PriceAllInclusive === val}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`price-inclusive-${val}`}>{val}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1PriceAllInclusive && <span className="error">This field is required*</span>}
                </div>

                {/* Price Negotiable */}
                <div>
                    <label>Price Negotiable</label>
                    <div className="radio-group">
                        {["Yes", "No"].map((val) => (
                            <div className="radio-option" key={val}>
                                <input
                                    type="radio"
                                    name="bhk1PriceNegotiable"
                                    value={val}
                                    id={`price-negotiable-${val}`}
                                    checked={data.bhk1PriceNegotiable === val}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`price-negotiable-${val}`}>{val}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1PriceNegotiable && <span className="error">This field is required*</span>}
                </div>

                {/* Preferred Cash Type */}
                <div>
                    <label>Preferred Cash Type</label>
                    <div className="checkbox-group">
                        {["Cash", "Cheque"].map((type) => (
                            <div className="checkbox-option" key={type}>
                                <input
                                    type="checkbox"
                                    name="bhk1PreferredCashType"
                                    value={type}
                                    id={`cash-type-${type}`}
                                    checked={data.bhk1PreferredCashType.includes(type)}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`cash-type-${type}`}>{type}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1PreferredCashType && <span className="error">This field is required*</span>}
                </div>

                {/* Floor Plan Upload */}
                <div>
                    <label>Upload Floor Plan</label>
                    <input
                        type="file"
                        name="bhk1FloorPlan"
                        accept="image/*"
                        onChange={handleInputChange}
                    />
                    {errors.bhk1FloorPlan && <span className="error">This field is required*</span>}
                </div>
            </div>
        );
    };

    // 2BHK section



    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        setData((prevState) => {
            if (type === "file") {
                return { ...prevState, [name]: files[0] };
            }
            if (type === "checkbox") {
                const updatedArray = checked
                    ? [...prevState[name], value]
                    : prevState[name].filter((item) => item !== value);
                return { ...prevState, [name]: updatedArray };
            }
            return { ...prevState, [name]: value };
        });

        if (errors[name]) {
            setErrors((prevErrors) => {
                const { [name]: removedError, ...restErrors } = prevErrors;
                return restErrors;
            });
        }
    };


    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/commercial/getsingleproperty/${id}`);
            if (!response.ok) throw new Error("Failed to fetch data");

            const res = await response.json();
            console.log("Raw fetched data:", res);

            // Utility function to safely parse JSON
            const parseJSON = (field, fallback = []) => {
                try {
                    return typeof field === "string" ? JSON.parse(field) : field || fallback;
                } catch {
                    return fallback;
                }
            };

            // Normalize flatType to ensure "type" is present
            const flatTypesRaw = parseJSON(res.flatType);
            const normalizedFlatTypes = flatTypesRaw.map((flat, i) => ({
                ...flat,
                type: flat.type || `${i === 0 ? "1BHK" : `${i + 1}BHK`}`
            }));

            // Build parsed data
            const parsedData = {
                ...res,
                amenities: parseJSON(res.amenities),
                locationAdvantage: parseJSON(res.locationAdvantage),
                locationAdvantages: parseJSON(res.locationAdvantage),
                formImages: parseJSON(res.formImages),
                carpetArea: parseJSON(res.carpetArea),
                flatType: normalizedFlatTypes,
                security: parseJSON(res.security),
                water_supply: parseJSON(res.water_supply),
            };

            // Filter out flatTypes with valid builtUpAreas
            const validFlatTypes = parsedData.flatType.filter(flat =>
                Array.isArray(flat.builtUpAreas) &&
                flat.builtUpAreas.some(area => area.value?.trim() !== "")
            );

            // Extract specific data from each flatType
            const extractFlatData = (flatType, prefix) => {
                const flatData = validFlatTypes.find(flat => flat.type === flatType);
                return flatData ? {
                    [`${prefix}BuiltUpAreas`]: flatData.builtUpAreas?.map(item => ({
                        value: item.value || "",
                        expectedPrice: item.expectedPrice || "",
                        showMinus: false,
                    })) || [],
                    [`${prefix}CarpetAreas`]: flatData.carpetAreas || [{ value: "", showMinus: false }],
                    [`${prefix}SuperBuiltUpAreas`]: flatData.superBuiltUpAreas || [{ value: "", showMinus: false }],
                    [`${prefix}Bedrooms`]: flatData.bedrooms || "",
                    [`${prefix}Balconies`]: flatData.balconies || "",
                    [`${prefix}Bathrooms`]: flatData.bathrooms || "",
                    [`${prefix}FurnishStatus`]: flatData.furnishStatus || "",
                    [`${prefix}ConditionOfFlat`]: flatData.conditionOfFlat || "",
                    [`${prefix}MonthlyMaintenance`]: flatData.monthlyMaintenance || "",
                    [`${prefix}PriceAllInclusive`]: flatData.priceAllInclusive || "",
                    [`${prefix}PriceNegotiable`]: flatData.priceNegotiable || "",
                    [`${prefix}PreferredCashType`]: flatData.preferredCashType || [],
                    [`${prefix}LoanFacility`]: flatData.loanFacility || "",
                    [`${prefix}DocumentsAvailable`]: flatData.documentsAvailable || "",
                    [`${prefix}FloorPlan`]: flatData.floorPlan || "",
                } : {};
            };

            // ✅ Set state
            setData(prev => ({
                ...prev,
                ...parsedData,
                flatType: validFlatTypes.map(ft => ft.type),
                ...extractFlatData("1RK", "rk"),
                ...extractFlatData("1BHK", "bhk1"),
                ...extractFlatData("2BHK", "bhk2"),
                ...extractFlatData("3BHK", "bhk3"),
                ...extractFlatData("4BHK", "bhk4"),
            }));

            // Additional state setters
            setAvailabilityStatus(res.availability || "");
            setSelectedAmenities(parsedData.amenities);
            setSelectedLocationAdvantages(parsedData.locationAdvantages);
            setSelectedWaterSupply(parsedData.water_supply);
            setSelectedSecurity(parsedData.security);

        } catch (error) {
            console.error("Error fetching property data:", error);
        }
    };




    useEffect(() => {
        fetchAmenities();
        fetchLocationAdvantages();
        fetchCategory();
        fetchSecurityFeature();
        fetchWaterSupply();
        // fetchDataProperty();
    }, []);

    useEffect(() => {
        fetchData();
    }, [id]);


    const fetchAmenities = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/amenities/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setAmenities(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchLocationAdvantages = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/location/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setLocationAdvantages(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching location advantages:", error);
        }
    };

    const fetchWaterSupply = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/water-supply/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setWaterSupply(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchSecurityFeature = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/security/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setSecurity(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchCategory = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_LINK}/propertycategory/all/${isLoggedIn.user_id}`);
            const activeAmenities = response.data.filter(amenity => amenity.status === 'active');
            setCategory(activeAmenities.reverse());

        } catch (error) {
            console.error('Error fetching amenities:', error);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(false);

        // if (validateFields()) {


        const bhk1Details = {

            carpetAreas: data.bhk1CarpetAreas,
            builtUpAreas: data.bhk1BuiltUpAreas,
            superBuiltUpAreas: data.bhk1SuperBuiltUpAreas,
            bedrooms: data.bhk1Bedrooms,
            balconies: data.bhk1Balconies,
            bathrooms: data.bhk1Bathrooms,
            furnishStatus: data.bhk1FurnishStatus,
            conditionOfFlat: data.bhk1ConditionOfFlat,
            expectedPrice: data.bhk1ExpectedPrice,
            monthlyMaintenance: data.bhk1MonthlyMaintenance,
            priceAllInclusive: data.bhk1PriceAllInclusive,
            priceNegotiable: data.bhk1PriceNegotiable,
            preferredCashType: data.bhk1PreferredCashType,
            loanFacility: data.bhk1LoanFacility,
            documentsAvailable: data.bhk1DocumentsAvailable,
            floorPlan: data.bhk1FloorPlan,
        };




        const formDataPayload = new FormData();

        const flatTypeData = [

            {
                ...bhk1Details,
                floorPlan: data.bhk1FloorPlan ? data.bhk1FloorPlan.name : null,
            },

        ];

        formDataPayload.append("flatType", JSON.stringify(flatTypeData));
        formDataPayload.append("building_name", data.building_name);
        formDataPayload.append("address", data.address);
        formDataPayload.append("city", data.city);
        formDataPayload.append("user_id", isLoggedIn.user_id);
        formDataPayload.append("amenities", JSON.stringify(selectedAmenities));
        formDataPayload.append("totalFloors", data.totalFloors);
        formDataPayload.append("floorLevel", data.floorLevel);
        formDataPayload.append("availability", availabilityStatus);
        formDataPayload.append("ageOfBuilding", data.ageOfBuilding);
        formDataPayload.append("possesionTill", data.possesionTill);
        formDataPayload.append("under_construction", data.under_construction);
        formDataPayload.append("ownership", data.ownership);
        formDataPayload.append("facing", data.facing);
        formDataPayload.append("brokage", data.brokage);
        formDataPayload.append("parking", data.parking);
        formDataPayload.append("booking_amount", data.booking_amount);
        formDataPayload.append("locationAdvantage", JSON.stringify(selectedLocationAdvantages));
        formDataPayload.append("water_supply", JSON.stringify(selectedWaterSupply));
        formDataPayload.append("security", JSON.stringify(selectedsecurity));
        formDataPayload.append("virtual_tour", data.virtual_tour);
        formDataPayload.append("developer_name", data.developer_name);
        formDataPayload.append("developer_description", data.developer_description);
        formDataPayload.append("property_description", data.property_description);
        // ✅ Handle file uploads (Update floor plans if new ones exist)
        if (data.floorPlan) {
            formDataPayload.append("floorPlan", data.floorPlan);
        }
        if (data.dev_logo) {
            formDataPayload.append("dev_logo", data.dev_logo); // Match the backend field name
        }
        uploadedFiles.forEach((image, index) => {
            formDataPayload.append(`formImages`, image);
        });

        if (data.rkFloorPlan) {
            formDataPayload.append("rkFloorPlan", data.rkFloorPlan);
        }
        if (data.bhk1FloorPlan) {
            formDataPayload.append("bhk1FloorPlan", data.bhk1FloorPlan);
        }
        if (data.bhk2FloorPlan) {
            formDataPayload.append("bhk2FloorPlan", data.bhk2FloorPlan);
        }
        if (data.bhk3FloorPlan) {
            formDataPayload.append("bhk3FloorPlan", data.bhk3FloorPlan);
        }
        if (data.bhk4FloorPlan) {
            formDataPayload.append("bhk4FloorPlan", data.bhk4FloorPlan);
        }

        // ✅ Track deleted images


        try {
            const response = await fetch(`${process.env.REACT_APP_LINK}/commercial/update-property/${id}`, {
                method: "PUT",
                body: formDataPayload,
            });
            const result = await response.json();
            if (response.ok) {
                alert("Property Updated Successfully!");
                navigate(`/`)
                setLoad(true);
            } else {
                setLoad(true);
                console.error("Error updating property:", result.message);
            }
        } catch (error) {
            setLoad(true);
            console.error("Network error:", error);
        }
        // } else {
        //     setLoad(true);
        //     toast.error("Please fill all required fields correctly.",{
        //         position: "top-center",
        //         autoClose: 2000,
        //     });
        // }
    };



    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <form className="property-form" onSubmit={handleSubmit}>
                    <h2>Property Details Form</h2>
                    <div>
                        <label>Building/Project Name</label>
                        <input type="text" name="building_name" value={data.building_name} onChange={handleInputChange} placeholder="Enter Building/Project Name"/>
                    </div>
                    <div>
                        <label>Address</label>
                        <input type="text" name="address" value={data.address} onChange={handleInputChange} placeholder="Enter Full Address"/>
                    </div>
                    <div>
                        <label>City</label>
                        <input type="text" name="city" value={data.city} onChange={handleInputChange} placeholder="Enter City"/>
                    </div>
                    {/* Amenities Input */}
                    <div className="location">
                        <div>
                            <label>Amenities</label>
                            <div className="button-group">
                                {amenities.map((amenity) => (
                                    <button
                                        type="button"
                                        key={amenity.id}
                                        className={`toggle-button ${selectedAmenities.includes(amenity.name) ? "selected" : ""}`}
                                        onClick={() => toggleAmenity(amenity.name)}
                                    >
                                        {amenity.name}
                                    </button>
                                ))}



                            </div>
                        </div>
                    </div>

                    {/* <div className="form-container">
                    <div className="post-input">
                        <label>Flat Type</label>
                        <div className="checkbox-group">
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="1RK"
                                    id="flattype-1RK"
                                    checked={data.flatType.includes("1RK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-1RK">1RK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="1BHK"
                                    id="flattype-1BHK"
                                    checked={data.flatType.includes("1BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-1BHK">1BHK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="2BHK"
                                    id="flattype-2BHK"
                                    checked={data.flatType.includes("2BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-2BHK">2BHK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="3BHK"
                                    id="flattype-3BHK"
                                    checked={data.flatType.includes("3BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-3BHK">3BHK</label>
                            </div>
                            <div className="checkbox-option">
                                <input
                                    type="checkbox"
                                    name="flatType"
                                    value="4BHK"
                                    id="flattype-4BHK"
                                    checked={data.flatType.includes("4BHK")}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor="flattype-4BHK">4BHK</label>
                            </div>
                        </div>
                    </div>

                    
                    {data.flatType.includes("1RK") && render1RKSection()}
                    {data.flatType.includes("1BHK") && render1BHKSection()}
                    {data.flatType.includes("2BHK") && render2BHKSection()}
                    {data.flatType.includes("3BHK") && render3BHKSection()}
                    {data.flatType.includes("4BHK") && render4BHKSection()}
                </div> */}
                    {render1BHKSection()}

                    <div>
                        <label>Total Number of Floors</label>
                        <input type="number" name="totalFloors" value={data.totalFloors} onChange={handleInputChange} placeholder="Enter Total Number of Floors"/>
                    </div>
                    <div>
                        <label>Floor Number</label>
                        <input type="number" name="floorLevel" value={data.floorLevel} onChange={handleInputChange} placeholder="Enter Floor Number (e.g., 1, 2, etc.)"/>
                    </div>

                    <div className="radio-group">
                        <label>Availability Status</label>
                        <input
                            type="radio"
                            id="availability-ready"
                            name="availability"
                            value="Ready to Move"
                            checked={availabilityStatus === "Ready to Move"}
                            onChange={() => setAvailabilityStatus("Ready to Move")}
                        />
                        <label htmlFor="availability-ready">Ready to Move</label>
                        <input
                            type="radio"
                            id="availability-under"
                            name="availability"
                            value="Under Construction"
                            checked={availabilityStatus === "Under Construction"}
                            onChange={() => setAvailabilityStatus("Under Construction")}
                        />
                        <label htmlFor="availability-under">Under Construction</label>
                    </div>
                    {availabilityStatus === "Ready to Move" ? (
                        <div>
                            <label>Age of Building (years)</label>
                            <input type="text" name="ageOfBuilding" placeholder="Enter Age of Building" value={data.ageOfBuilding} onChange={handleInputChange} />
                        </div>
                    ) : (
                        <div>
                            <label>Possession Till</label>
                            <input type="date" name="possesionTill" placeholder="Select Possession Date" value={data.possesionTill} onChange={handleInputChange} />
                        </div>
                    )}
                    <div className="radio-group">
                        <label>Ownership</label>
                        <input type="radio" id="freehold"  name="ownership" value="freehold" checked={data.ownership==="freehold"} onChange={handleInputChange} />
                        <label htmlFor="freehold">Freehold</label>
                        <input type="radio" id="leasehold"  name="ownership" value="leasehold" checked={data.ownership==="leasehold"} onChange={handleInputChange} />
                        <label htmlFor="leasehold">Leasehold</label>
                        <input type="radio" id="SRA-Redevelopment"  name="ownership" value="SRA-Redevelopment" checked={data.ownership === "SRA-Redevelopment"} onChange={handleInputChange} />
                        <label htmlFor="SRA-Redevelopment">SRA Redevelopment</label>
                        <input type="radio" id="Society-Redevelopment"  name="ownership" checked={data.ownership === "Society-Redevelopment"} value="Society-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="Society-Redevelopment">Society Redevelopment</label>
                        <input type="radio" id="MHADA-Redevelopment"  name="ownership" checked={data.ownership==="MHADA-Redevelopment"} value="MHADA-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="MHADA-Redevelopment">MHADA Redevelopment</label>
                        <input type="radio" id="BMC-Redevelopment"  name="ownership" checked={data.ownership==="BMC-Redevelopment"} value="BMC-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="BMC-Redevelopment">BMC Redevelopment</label>
                    </div>
                    <div className="radio-group">
                        <label>Facing Direction</label>
                        <input type="radio" id="facing-north" name="facing" value="north"
                            checked={data.facing === "north"}
                            onChange={handleInputChange} />
                        <label htmlFor="facing-north">North</label>
                        <input type="radio" id="facing-south" name="facing" value="south" checked={data.facing === "south"} onChange={handleInputChange} />
                        <label htmlFor="facing-south">South</label>
                        <input type="radio" id="facing-east" name="facing" value="east" checked={data.facing === "east"} onChange={handleInputChange} />
                        <label htmlFor="facing-east">East</label>
                        <input type="radio" id="facing-west" name="facing" value="west" checked={data.facing === "west"} onChange={handleInputChange} />
                        <label htmlFor="facing-west">West</label>
                    </div>
                    <div className="radio-group">
                        <label className="margin-top-10px-oms-div">Brokage</label>
                        <input
                            type="radio"
                            id="brokage-yes"
                            name="brokage"
                            // value={data.brokage}
                            checked={data.brokage === "yes"}
                            value="yes"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-yes">Yes</label>
                        <input
                            type="radio"
                            id="brokage-no"
                            name="brokage"
                            checked={data.brokage === "no"}
                            value="no"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-no">No</label>
                    </div>
                    <div>
                        <label>Parking</label>
                        <input type="number" name="parking" placeholder="Enter Number of Parking Slots" value={data.parking} onChange={handleInputChange}/>
                    </div>
                    <div>
                        <label>Booking Amount(₹)</label>
                        <input type="number" name="booking_amount" placeholder="Enter Booking Amount" value={data.booking_amount} onChange={handleInputChange}/>
                    </div>
                    <div className="location">
                        <div>
                            <label>Location Advantages</label>
                            <div className="button-group">
                                {locationAdvantages.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedLocationAdvantages.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleLocationAdvantage(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>

                    </div>
                    <div className="location">
                        <div>
                            <label>Water Supply</label>
                            <div className="button-group">
                                {watersupply.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedWaterSupply.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleWaterSupply(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="location">
                        <div>
                            <label>Security</label>
                            <div className="button-group">
                                {security.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedsecurity.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleSecurity(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div>
                        <label>Virtual Tour (URL)</label>
                        <input type="text" name="virtual_tour" placeholder="Enter Virtual Tour URL" value={data.virtual_tour} onChange={handleInputChange} />
                    </div>
                    {/* <div className="radio-group">
                        <label>Property Category</label>
                        {
                            category.map((ele, idx) => (
                                <React.Fragment key={idx}>
                                    <input
                                        type="radio"
                                        id={`category-${ele.name}`}
                                        name="category"
                                        value={ele.name}
                                        checked={ele.name === ele.name}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor={`category-${ele.name}`}>{ele.name}</label>
                                </React.Fragment>
                            ))
                        }


                    </div> */}
                    <div className='margin-top-10px-oms-div'>
                        <label>Developer Logo</label>
                        <input
                            type="file"
                            name="dev_logo"
                            accept="image/*"
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="property-images">
                        {/* <h3>Property Images</h3> */}

                        <div className="image-gallery">

                            <div className="image-container1">
                                <img
                                    src={`${process.env.REACT_APP_LINK}/Images/Store/${data.dev_logo}`}
                                    // alt={`Property Image ${index + 1}`}
                                    className="property-image"
                                />

                            </div>

                        </div>

                    </div>

                    <div>
                        <label>Developer Name</label>
                        <input
                            type="text"
                            name="developer_name"
                            placeholder="Enter Developer Name"
                            value={data.developer_name}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Developer Description</label>
                        <input
                            type='text'
                            name="developer_description"
                            placeholder="Enter Developer Description"
                            value={data.developer_description}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Property Description</label>
                        <input
                            type='text'
                            name="property_description"
                            placeholder="Enter Property Description"
                            value={data.property_description}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="post-property-image">
                        <p className="post-property-image-head">
                            Upload your image
                        </p>
                        <p className="post-property-limits">
                            You can upload up to 20 images, with a total size limit of 20MB, in JPG or JPEG format.
                        </p>
                        <div
                            className={`post-property-image-container ${dragging ? 'dragging' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                        >
                            <i className="fa-solid fa-arrow-up-from-bracket"></i>
                            <p>Drag and drop your images or</p>
                            <button className="browse-files" onClick={handleBrowseClick}>
                                Browse images
                            </button>
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                multiple
                                accept=".jpg, .jpeg, .webp, .png"
                                onChange={handleFileChange}
                            />
                        </div>
                        <div className="property-images">
                            <h3>Property Images</h3>
                            {data.formImages && data.formImages.length > 0 ? (
                                <div className="image-gallery">
                                    {data.formImages.map((img, index) => (
                                        <div key={index} className="image-container">
                                            <img
                                                src={`${process.env.REACT_APP_LINK}/Images/Store/${img}`}
                                                alt={`Property Image ${index + 1}`}
                                                className="property-image"
                                            />
                                            <button type='button' className="delete-image-btn" onClick={() => handleDeleteImage(index)}>
                                                <i class="fa-solid fa-xmark"></i>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>No images available</p>
                            )}
                        </div>



                        <div className="upload-file-container">
                            {uploadedFiles.length > 0 ? (
                                <>
                                    <p className="upload-file-head">Uploaded Files:</p>
                                    <ul className="upload-file-list">
                                        {uploadedFiles.map((file, index) => (
                                            <li key={index} className="upload-file-item">
                                                <span>{file.name} ({formatFileSize(file.size)})</span>
                                                <button
                                                    className="delete-file-btn"
                                                    onClick={() => handleDeleteFile(index)}
                                                >
                                                    <i className="fa-solid fa-xmark"></i>
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            ) : (
                                <p className="no-files-message">No files uploaded yet.</p>
                            )}
                        </div>
                    </div>
                    {
                        load ? <button type="submit" className='post-property-submit'>Submit</button> :
                            <button type="button" className='post-property-submit' disabled>Loading...</button>
                    }

                </form>
            </div>

            <ToastContainer />
        </>
    );
};

export default CommercialEdit;

